import React from "react";
import { Box, Divider } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import SummarySection from "../components/summary";
import { Checklist } from "../components/checklist";
import OrdersChartSection from "../components/ordersChart";
import FactorsSummary from "../components/factorSummary";
import IssuedFactorsChartSection from "../components/issuedFactorsChart";

const Dashboard = () => {
	return (
		<Box
			maxWidth={"100%"}
			flexGrow={1}
			gap={4}
			display={"flex"}
			flexDirection={"column"}
			alignItems={"stretch"}
		>
			<Grid container width={"100%"} spacing={4}>
				<Grid xs={12} md={6}>
					<SummarySection />
				</Grid>
				<Grid xs={12} md={6}>
					<Checklist />
				</Grid>
			</Grid>
			<Divider />
			<OrdersChartSection />
			<Divider />
			<FactorsSummary />
			<Divider />
			<IssuedFactorsChartSection />
		</Box>
	);
};

export default Dashboard;
